<template>
    <div class="columns is-mobile">
        <div class="column is-4">
            <figure class="image">
            <img src="https://assets.webbank.com/people-gitler.png" class="is-rounded" alt="Phil Gitler">
            </figure>
        </div>
        <div class="column">
            <h2 class="people-name">Phil Gitler</h2>
            <h3 class="people-title">SVP Head of Asset Finance</h3>
            <p class="people-bio">
Phil brings more than 25 years of asset financing experience in the specialty finance and fintech sectors across investment management, investment banking, capital markets, and corporate development. Before joining WebBank, Mr. Gitler served as EVP and Chief Strategy Officer at Attain Finance (f/k/a CURO Financial Technologies). Earlier, he spent nearly eight years as a Managing Director and Portfolio Manager at Waterfall Asset Management, LLC, where he helped build and lead the asset-backed direct lending strategy. He began his career in capital markets and asset &amp; principal finance at Goldman Sachs &amp; Co. LLC and Merrill Lynch &amp; Co., where he spent 14 years. Mr. Gitler received his M.B.A. from the Wharton School of the University of Pennsylvania and a Bachelor of Science degree in Finance from The Pennsylvania State University.
            </p>
        </div>
    </div>
</template>

<script>
export default {

}
</script>
